(function () {
  angular.module("akitabox.desktop.job", [
    "ui.router",
    "akitabox.constants",
    "akitabox.desktop.export.list",
  ]);
})();
